import { DhtmlxGanttChart } from 'cv-library-react-web';
import { themes } from 'cv-react-core';

import getTheme from './DhtmlxGanttChart.theme';

const { themeComponent } = themes;

export default themeComponent(DhtmlxGanttChart, getTheme);
